<template>
  <div>
    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Site Map</h2>
              <p class="listing-page-desc">Insurance <span style="color:var(--secondary-color);">Bazaar</span></p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img
              class="img-fluid"
              alt="icon"
              :src="require('@/assets/images/claim-policy-right-img.svg')"
            />
          </div>
        </div>
      </div>
      <div class="container article-box">
        <div class="row pt-4">

          <div class="col-md-4 text-center" v-for="(mainClass, index) in mainClasses" :key="'class' + index">
            <div class="in-sitemap-heading">{{mainClass.name}}</div>
            <div class="d-flex align-items-center mb-3 in-cursor-pointer" v-for="(subClass, index) in mainClass.sub_classes" :key="'subclass' + index" @click="startAcquisition(mainClass.id, mainClass.has_category, '', subClass.subclass_id)">
              <div class="in-sitemap-img">
                <img class="img-fluid" :src="subClass.logo" alt="car-img">
              </div>
              <div class="in-sitemap-product">{{ subClass.name }}</div>
            </div>

          </div>
          <!-- <div class="col-md-4 text-center">
            <div class="in-sitemap-heading">Home</div>
          </div>
          <div class="col-md-4 text-center">
            <div class="in-sitemap-heading">Health</div>
          </div>

          <div class="col-md-4 text-center">
            <div class="in-sitemap-heading">Life</div>
          </div>
          <div class="col-md-4 text-center">
            <div class="in-sitemap-heading">Travel</div>
          </div>
          <div class="col-md-4 text-center">
            <div class="in-sitemap-heading">Personal Accident</div>
          </div> -->

        </div>
      </div>
    </div>
  </div>
</template>

// <script>
//   import comingSoon from '@/pages/ComingSoon';
  
//   export default {
//     name: 'SiteMap',
//     data () {
//       return {
        
//       }
//     },
//     components: {
//       comingSoon
//     },
//     created () {
//     },
//     methods: {
//     }
//   }
// </script>
<script>
  

  export default {
    name: 'ComingSoon',
    data () {
      return {
        popularSubclasses: [],
        mainClasses: []
      }
    },
    components: {
      
    },
    created () {
      const self = this;
      self.getProductsData();
    },
    methods: {
      async getProductsData() {
        const self = this;
        const promises = [];
        self.showLoader = true;

        promises.push(await axios.get('get_popular_subclasses').then(function (resp) {
          if(resp.data.code == 200) {
            self.popularSubclasses = resp.data.data.subclasses;
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return Promise.reject(resp);
          }
        }).catch(function (error) {
          self.showLoader = false;
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
          return Promise.reject(error);
        }));

        promises.push(await axios.get('get_mainclasses').then(function (resp) {
          if(resp.data.code == 200) {
            self.mainClasses = resp.data.data.main_classes;
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return Promise.reject(resp);
          }
        }).catch(function (error) {
          self.showLoader = false;
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
          return Promise.reject(error);
        }));

        Promise.all(promises).then(() => {
          self.showLoader = false;
        });
      },
      startAcquisition(classId, hasCategory, categoryId, subClassId) {
        const self = this;
        self.$router.push({ name: 'Acquisition', params: { classId: classId, hasCategory: hasCategory, categoryId: categoryId, subClassId: subClassId, redirectFrom: 'products' } });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/SiteMap.vue